module.exports = __webpack_public_path__ + "img/bomb.c83e1788.png";